import { OI } from "../../onam/mark";
import { FEATURES } from "../../onam/features";
interface CheckIconComponentProps {
  primaryColor?: string;
  secondaryColor?: string;
  onClick?: (value: any) => void;
  style?: React.CSSProperties;

}

const BaseCheckIconSVGComponent = ({ primaryColor, secondaryColor, onClick, style }: CheckIconComponentProps) => (
<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
<path d="M5.08301 12L10.083 17L20.083 7" stroke="#12B76A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>


);

/* With the ONAM skin (FEATURES.curationSkin) this draws ONAM's "check" glyph instead (onam/mark.tsx). */
const CheckIconSVGComponentSkin = (props: any) =>
  FEATURES.curationSkin ? (
    <OI n="check" size={props.size || 18} className={props.className} style={props.style} onClick={props.onClick} title={props.title} color={props.color}
      onMouseOver={props.onMouseOver} onMouseOut={props.onMouseOut} onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave} />
  ) : (
    <BaseCheckIconSVGComponent {...props} />
  );
export default CheckIconSVGComponentSkin;
